<template>
  <section class="level" style="align-items:start;">
    <div class="card events-card" style="width:100%;margin-right:5px;">
      <header class="card-header">
        <p class="card-header-title has-text-danger is-centered">
          <span class="icon is-small">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          &nbsp; Red Zone (Needs Attention)
        </p>
      </header>
      <div class="card-table">
        <div class="content">
          <table class="table is-size-5 is-striped">
            <thead>
              <tr>
                <th>Device</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="key" v-for="(device, key) in redDevices">
                <td>
                  <a @click="showDevice(device)">
                    <i class="fas fa-tools"></i> Device {{ device }}</a
                  >
                </td>
                <td>
                  <span class="is-size-6 has-text-danger">
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ filteredDevices[device]["reason"] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card events-card" style="width:100%;margin-left:5px;">
      <header class="card-header">
        <p class="card-header-title has-text-success is-centered">
          <span class="icon is-small has-text-success">
            <i class="fas fa-check-circle"></i>
          </span>
          &nbsp; Green Zone (Stable)
        </p>
      </header>
      <div class="card-table">
        <div class="content">
          <table class="table is-size-5 is-striped">
            <thead>
              <tr>
                <th>Device</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="key" v-for="(device, key) in greenDevices">
                <td>
                  <a @click="showDevice(device)">Device {{ device }}</a>
                </td>
                <td>
                  <span class="icon is-small has-text-success">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { deviceMapMinMax } from "./utility";
export default {
  props: {
    devices: Object
  },
  methods: {
    simplifyDate(date) {
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },
    showDevice(i) {
      //   console.log(i);
      this.$emit("updateMenu", "dashboard", parseInt(i));
    },
    checkSensors(device) {
      let flag = false;
      let val = 0;
      Object.keys(device).forEach(function(sensor) {
        if (device[sensor].val) {
          if (device[sensor].val < deviceMapMinMax[sensor].min) {
            flag = true;
            val -= 1;
          } else if (device[sensor].val > deviceMapMinMax[sensor].max) {
            flag = true;
            val += 1;
          }
        }
      });
      return [flag, val];
    }
  },
  computed: {
    filteredDevices: function() {
      let vm = this;
      let result = {};
      Object.keys(vm.devices).forEach(device => {
        result[device] = {};
        if (!vm.devices[device]["status"]) {
          result[device]["status"] = false;
          result[device]["reason"] = "Offline";
        } else {
          let res = vm.checkSensors(vm.devices[device]);
          if (res[0]) {
            result[device]["status"] = true;
            result[device]["reason"] =
              res[1] > 0 ? "Mostly High Value" : "Mostly Low Value";
          } else {
            result[device]["status"] = true;
          }
        }
      });
      return result;
    },
    redDevices: function() {
      let vm = this;
      let result = [];
      Object.keys(vm.filteredDevices).forEach(device => {
        if (!vm.filteredDevices[device]["status"]) {
          result.push(device);
        }
      });
      return result;
    },
    greenDevices: function() {
      let vm = this;
      let result = [];
      Object.keys(vm.filteredDevices).forEach(device => {
        if (vm.filteredDevices[device]["status"]) {
          result.push(device);
        }
      });
      return result;
    }
  }
};
</script>

<style scoped>
.events-card .card-table {
  overflow-y: scroll;
}
.card-table {
  max-height: 80vh;
}
td {
  text-align: center !important;
}

th {
  text-align: center !important;
}
</style>
